import React, {useEffect, useRef, useState} from "react";
import classes from "./TiptapMenuNew.module.css";

import { ReactComponent as UNDO } from "./images/undo.svg";
import { ReactComponent as REDO } from "./images/redo.svg";
import { ReactComponent as BOLD } from "./images/bold.svg";
import { ReactComponent as ITALIC } from "./images/italic.svg";
import { ReactComponent as UNDERLINE } from "./images/underline.svg";
import { ReactComponent as CLEAN } from "./images/clear-formating.svg";
import { ReactComponent as EXPANDED } from "./images/expand.svg";
import { ReactComponent as COLLAPSE } from "./images/collapse.svg";
import { ReactComponent as TEXT_COLOR } from "./images/font-color-icon.svg";
import { ReactComponent as LATEX_LOGO } from "./images/LaTeX_logo.svg";
import { ReactComponent as HIGHLIGHT_COLOR } from "./images/highlight-color-icon.svg";
import { ReactComponent as PREVIEW } from "./images/preview.svg";
import { ReactComponent as CART_DOWN } from "./images/cart-down.svg";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import {
    BOLD_TEXT, BUTTON, CLEAN_FORMAT_TEXT, CLOSE, CLOSE_MODAL,
    HIGHLIGHT_COLOR_TEXT,
    ITALIC_TEXT,
    LATEX_EXPRESSION_TEXT, PREVIEW_CONTENT_TEXT, PREVIEW_TEXT, REDO_TEXT,
    TEXT_COLOR_TEXT, TEXTBOX,
    UNDERLINE_TEXT, UNDO_TEXT
} from "../../utils/constants";
import Modal from "react-bootstrap/Modal";
import {LatexHTMLInline} from "./latexParser";
import YuJaButton from "../standardization/YuJaButton";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {generateUUID} from "../../utils/helpers";
import FocusTrap from "../FocusTrap";

export const TipTapMenuBarNew = ({isOpen=true, editor, selectedQuestion, disabled=false, ...props }) => {
    const [randomId, ] = useState(() => generateUUID());

    const defaultTextColor = "#000000";
    const defaultHighlightColor = "#ffc078";
    let windowDimensions = useWindowDimensions();
    const [barWidth, setBarWidth] = useState(0);
    const barRef = useRef();
    const moreIconRef = useRef();
    const restMenuRef = useRef();
    const [menuList, setMenuList] = useState([]);
    const [restMenu, setRestMenu] = useState([]);
    const [expanded, setExpanded] = useState(false);
    const [textColor, setTextColor] = useState(defaultTextColor);
    const [highlightColor, setHighlightColor] = useState(defaultHighlightColor);
    const [previewModalShown, setPreviewModalShown] = useState(false);
    const [iconTransformStyle, setIconTransformStyle] = useState({});

    const itemGap = 10;
    const commonItemSize = 26;
    const colorItemSize = 40;

    let oneItem = 10 + commonItemSize;
    let twoItems = 10 + commonItemSize * 2 + itemGap;
    let threeItems = 10 + commonItemSize * 3 + itemGap * 2;
    let fourItems = 10 + commonItemSize * 3 + colorItemSize + itemGap * 3;
    let fiveItems = 10 + commonItemSize * 3 + colorItemSize * 2 + itemGap * 4;
    let sixItems = 10 + commonItemSize * 4 + colorItemSize * 2 + itemGap * 5;
    let sevenItems = 10 + commonItemSize * 5 + colorItemSize * 2 + itemGap * 6;
    let eightItems = 10 + commonItemSize * 6 + colorItemSize * 2 + itemGap * 7;
    let nineItems = 10 + commonItemSize * 7 + colorItemSize * 2 + itemGap * 8;
    let tenItems = 10 + commonItemSize * 8 + colorItemSize * 2 + itemGap * 9;


    const render = () => {
        if (!barRef.current) {
            return;
        }

        let barWidth = barRef.current.clientWidth;

        let menuCopy = [
            {key: "UNDO", icon: UNDO, title: UNDO_TEXT},
            {key: "REDO", icon: REDO, title: REDO_TEXT},
            {key: "BOLD", icon: BOLD, title: BOLD_TEXT},
            {key: "ITALIC", icon: ITALIC, title: ITALIC_TEXT},
            {key: "UNDERLINE", icon: UNDERLINE, title: UNDERLINE_TEXT},
            {key: "TEXT_COLOR", icon: TEXT_COLOR, title: TEXT_COLOR_TEXT},
            {key: "HIGHLIGHT_COLOR", icon: HIGHLIGHT_COLOR, title: HIGHLIGHT_COLOR_TEXT},
            {key: "LATEX",
                icon: LATEX_LOGO,
                title: LATEX_EXPRESSION_TEXT
            },
            {key: "CLEAN", icon: CLEAN, title: CLEAN_FORMAT_TEXT},
            {key: "PREVIEW", icon: PREVIEW, title: PREVIEW_TEXT},

        ];

        if (barWidth < twoItems) {
            setMenuList(menuCopy.splice(0, 0));
            setRestMenu(menuCopy);
            setBarWidth(oneItem);
        } else if (barWidth < threeItems) {
            setMenuList(menuCopy.splice(0, 1));
            setRestMenu(menuCopy);
            setBarWidth(twoItems);
        } else if (barWidth < fourItems) {
            setMenuList(menuCopy.splice(0, 2));
            setRestMenu(menuCopy);
            setBarWidth(threeItems);
        } else if (barWidth < fiveItems) {
            setMenuList(menuCopy.splice(0, 3));
            setRestMenu(menuCopy);
            setBarWidth(fourItems);
        } else if (barWidth < sixItems) {
            setMenuList(menuCopy.splice(0, 4));
            setRestMenu(menuCopy);
            setBarWidth(fiveItems);
        } else if (barWidth < sevenItems) {
            setMenuList(menuCopy.splice(0, 5));
            setRestMenu(menuCopy);
            setBarWidth(fiveItems);
        } else if (barWidth < eightItems) {
            setMenuList(menuCopy.splice(0, 6));
            setRestMenu(menuCopy);
            setBarWidth(fourItems);
        } else if (barWidth < nineItems) {
            setMenuList(menuCopy.splice(0, 7));
            setRestMenu(menuCopy);
            setBarWidth(threeItems);
        } else if (barWidth < tenItems) {
            setMenuList(menuCopy.splice(0, 8));
            setRestMenu(menuCopy);
            setBarWidth(twoItems);
        } else {
            setMenuList(menuCopy);
            setRestMenu([]);
            setBarWidth(0);
            setPreviewModalShown(false);
        }
    }

    useEffect(() => {
        setExpanded(false);
        setPreviewModalShown(false);
    }, [selectedQuestion]);

    const setRestMenuPosition = () => {
        if (!moreIconRef.current || !restMenuRef.current) {
            return;
        }
        const {left, width, height, top, } = moreIconRef.current.getBoundingClientRect();
        const {width: menuWidth, height: menuHeight, } = restMenuRef.current.getBoundingClientRect();
        let menu = document.querySelector(`[data-tiptap-rest-menu-id='${randomId}']`);
        if (!menu) {
            return;
        }
        menu.style.transform =  `translate(${left - (menuWidth - width + 1)}px, ${top - (menuHeight + 2)}px)`;
    }


    useEffect(() => {
        if (expanded && restMenu.length > 1) {
            document.addEventListener('scroll', setRestMenuPosition, true);
            setRestMenuPosition();
        } else {
            document.removeEventListener('scroll', setRestMenuPosition)
        }
    }, [restMenu, windowDimensions, randomId, expanded]);

    useEffect(() => {
        render();
    }, [isOpen, windowDimensions, selectedQuestion]);


    const onClick = (e, key) => {
        if (e.currentTarget.className.includes("disabled")) {
            return;
        }

        if (key === "UNDO") {
            if (editor.can().chain().focus().undo().run()) {
                editor.chain().focus().undo().run();
            }
        } else if (key === "REDO") {
            if (editor.can().chain().focus().redo().run()) {
                editor.chain().focus().redo().run();
            }
        } else if (key === "BOLD") {
            editor.chain().focus().toggleBold().run();
        } else if (key === "ITALIC") {
            editor.chain().focus().toggleItalic().run();
        } else if (key === "UNDERLINE") {
            editor.chain().focus().toggleUnderline().run();
        } else if (key === "LATEX") {
            const {state} = editor;
            editor.chain().focus().unsetBold().run();
            editor.chain().focus().unsetItalic().run();
            editor.chain().focus().unsetUnderline().run();
            editor.chain().focus().unsetColor().run();
            editor.chain().focus().unsetHighlight().run();

            let latexContent = '$latex $';
            editor.commands.insertContent(latexContent);
            let position = state.selection.anchor;
            // if (position > 1) {
            //     editor.commands.deleteRange({from: position, to: position + 2});
            //     if (editor.state.doc.content.size >=  position + latexContent.length + 2) {
            //         editor.commands.deleteRange({from: position + latexContent.length, to: position + latexContent.length + 2});
            //     }
            // }
            position = position + latexContent.length - 1
            editor.chain().focus().setTextSelection(position).run();
            // editor.commands.deleteRange({from: position - 1, to: position});

        } else if (key === "CLEAN") {
            editor.chain().focus().unsetBold().run();
            editor.chain().focus().unsetItalic().run();
            editor.chain().focus().unsetUnderline().run();
            editor.chain().focus().unsetAllMarks().run();
            editor.chain().focus().unsetColor().run();
            editor.chain().focus().unsetHighlight().run();
        } else if (key === "PREVIEW") {
            setPreviewModalShown(true);
        }
    }

    const setCustomizedColor = (e, key) => {
        if (key === "TEXT_COLOR") {
            setTextColor(e.target.value);
        } else {
            setHighlightColor(e.target.value);
        }
    }


    const toggleColor = (e, key) => {
        if (e.currentTarget.className.includes("disabled")) {
            return;
        }

        if (key === "TEXT_COLOR") {

            let curColor = editor.getAttributes('textStyle').color;
            if (curColor === textColor) {
                editor.chain().focus().setColor(defaultTextColor).run();
            } else {
                editor.chain().focus().setColor(textColor).run();
            }

        } else {
            editor.chain().focus().toggleHighlight({ color: highlightColor }).run();
        }
    }


    const renderMenuItems = (menuItemArr, expanded=true) => {
        return (menuItemArr.map(({ key, title, icon: Icon }, index) => {
            let isDisabled = false;
            let isActive = false;
            let isColorOption = key === "TEXT_COLOR" || key === "HIGHLIGHT_COLOR";
            if (!!disabled) {
                isDisabled = true;
            } else if (key === "UNDO") {
                isDisabled = !editor.can().chain().focus().undo().run();
            } else if (key === "REDO") {
                isDisabled = !editor.can().chain().focus().redo().run();
            } else if (key === "BOLD") {
                isActive = editor.isActive('bold');
            } else if (key === "ITALIC") {
                isActive = editor.isActive('italic');
            } else if (key === "UNDERLINE") {
                isActive = editor.isActive('underline');
            }



            return (
                <span
                    key={index}
                    tabIndex={!isColorOption ? 0 : -1}
                    className={`${classes.menuItem} ${isDisabled ? classes.disabled : ""} ${isActive ? classes.active : ""}`}
                    onClick={(e) => onClick(e, key)}
                    style={{width: isColorOption || key === "LATEX" ? "fit-content" : undefined}}
                    title={title}
                >
                    <Icon />

                    {isColorOption &&
                        <>
                           <span
                               tabIndex={0}
                               onMouseEnter={e => e.stopPropagation()}
                               className={`${classes.selectedColorBarContainer} ${isDisabled ? classes.disabled : ""}`}
                               onClick={(e) => toggleColor(e, key)}
                           >
                                <Icon/>
                                <span
                                    className={classes.selectedColorBar}
                                    style={{background: key === "TEXT_COLOR" ? textColor : highlightColor}}
                                />
                           </span>
                            <span className={`${classes.colorChangeDropDown} ${isDisabled ? classes.disabled : ""}`}>
                                <CART_DOWN/>
                                <input
                                    disabled={isDisabled}
                                    tabIndex={0}
                                    className={classes.colorPicker}
                                    onChange={e => setCustomizedColor(e, key)}
                                    type={"color"}
                                />
                            </span>
                        </>
                    }

                    </span>
            );
        }));
    }

    // useEffect(() => {
    //     const handleGlobalClick = (event) => {
    //         let menu = document.querySelector(`[data-tiptap-rest-menu-id='${randomId}']`);
    //         // Check if the click occurred outside of the menu
    //         if (expanded && !!menu && !menu.contains(event.target)) {
    //             setExpanded(false);
    //             if (props?.setOpen) {
    //                 props.setOpen(false);
    //             }
    //         }
    //     };
    //
    //     if (restMenu.length > 0 && expanded) {
    //         document.addEventListener('click', handleGlobalClick, true);
    //         // addClickEventHandler(handleGlobalClick);
    //     } else {
    //         setExpanded(false);
    //     }
    //
    //     return () => {
    //         document.removeEventListener('click', handleGlobalClick)
    //     };
    // }, [restMenu, expanded, randomId]);


    return (
        <div ref={barRef} className={classes.menuBar} {...props}>
            <FocusTrap isOpened={previewModalShown} setIsOpened={setPreviewModalShown}>
                <Modal
                    id="question-modal"
                    show={previewModalShown}
                    onHide={() => setPreviewModalShown(false)}
                    aria-labelledby="PREVIEW_MODAL_TITLE"
                    backdrop={true}
                    dialogClassName="question-modal2"
                >
                    <ModalClose tabIndex={0} role={BUTTON} aria-label={CLOSE_MODAL}
                                onClick={() => setPreviewModalShown(false)} className="modal-close" />
                    <Modal.Header style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Modal.Title as="h2" role={TEXTBOX} id="PREVIEW_MODAL_TITLE">
                            {PREVIEW_CONTENT_TEXT}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ display: "flex", alignItems: "center", minHeight: 100, overflow: "auto"}}>
                        <div style={{flex: 1}}/>
                        <LatexHTMLInline>{editor.getHTML()}</LatexHTMLInline>
                        <div style={{flex: 1}}/>
                    </Modal.Body>
                    <Modal.Footer>
                        <YuJaButton
                            onClick={() => setPreviewModalShown(false)}
                            wrapperStyle={{whiteSpace: "nowrap"}}
                        >
                            {CLOSE}
                        </YuJaButton>
                    </Modal.Footer>
                </Modal>
            </FocusTrap>
            {renderMenuItems(menuList)}
            {restMenu.length > 0 &&
                <>
                    <span
                        ref={moreIconRef}
                        tabIndex={0}
                        onClick={() => setExpanded(!expanded)}
                        className={`${classes.menuItem} ${expanded ? classes.active : ""}`}
                    >
                        {!expanded && <EXPANDED title={"More"} />}
                        {!!expanded && <COLLAPSE title={"More"} />}
                    </span>
                    <div
                        ref={restMenuRef}
                        data-tiptap-rest-menu-id={randomId}
                        className={classes.expandedMenuBar}
                        style={{width: barWidth, visibility: expanded ? "visible" : "hidden"}}
                    >
                        {renderMenuItems(restMenu, expanded)}
                    </div>
                </>
            }
        </div>
    )
}